import React from 'react'
import { Badge } from '@wmgtech/legato'

import { BadgeList } from 'components'
import { Can } from 'shared/abilities'
import { useToggleFollowZone } from 'modules/GlobalOverview/serviceHooks/useToggleFollowZone'
import { TZone, useZonesList } from '../../serviceHooks'
import { ENABLED_FEATURES } from 'shared/utils/featureFlags'

export const NotificationsZones = () => {
  const { zoneList } = useZonesList()
  const { onToggleZone, getZoneFollowed } = useToggleFollowZone()
  const onToggle = (value: TZone) => onToggleZone(value.id)

  return ENABLED_FEATURES.GLOBALHUB ? (
    <Can do={'access'} on={'GlobalHub'}>
      {zoneList.length ? (
        <BadgeList itemList={zoneList} onToggle={onToggle} title="Zones">
          {(zone: TZone) =>
            <Badge text={zone.name} containerStyle={getZoneFollowed(zone.id) ? 'solid' : 'outline'} colorType="dark" />
          }
        </BadgeList>
      ) : null}
    </Can>
  ) : null
}
